export default __webpack_public_path__ + "static/blob16-ccd7a43d0f75bdf2842461d778ebac54.svg";